var a = {
  tg: "tg",
  vk: "vk",
  max: "max"
};
export {
  a as EnumSocialIcons
};
